var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3269 15.44L21.8999 21.013M10.8 5.6C12.7882 5.6 14.4 7.21177 14.4 9.2M18.68 9.84C18.68 14.1699 15.1699 17.68 10.84 17.68C6.51009 17.68 3 14.1699 3 9.84C3 5.51009 6.51009 2 10.84 2C15.1699 2 18.68 5.51009 18.68 9.84Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch02);
export default __webpack_public_path__ + "static/media/search-02.7ba90281f77b0ed7781f1cd0a40852c1.svg";
export { ForwardRef as ReactComponent };